// src/store/store.js
import { configureStore } from '@reduxjs/toolkit';
import municipalityReducer from './slices/municipalitySlice';
import uiReducer from './slices/uiSlice';
import filterReducer from './slices/filterSlice';
import dataReducer from './slices/dataSlice';
import chatReducer from './slices/chatSlice';
import { municipalityApi } from './api/municipalityApi';
import { chitalishteApi } from './api/chitalishteApi';
import feedbackReducer from './slices/feedbackSlice';

export const store = configureStore({
  reducer: {
    municipalities: municipalityReducer,
    ui: uiReducer,
    filters: filterReducer,
    data: dataReducer,
    chat: chatReducer,
    feedback: feedbackReducer,
    [municipalityApi.reducerPath]: municipalityApi.reducer,
    [chitalishteApi.reducerPath]: chitalishteApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(municipalityApi.middleware)
      .concat(chitalishteApi.middleware),
});

export default store;